import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Elastic, TimelineLite} from "gsap";
import {ThorGameMode} from "../gamemode/ThorGameMode";
import {ThorRespinNudgeReelController} from "../reel/nudgereel/ThorRespinNudgeReelController";
import {ThorParsedGameData} from "../server/data/ThorParsedGameData";
import {ThorParsedInitData} from "../server/data/ThorParsedInitData";
import {ThorGameConfig} from "../ThorGameConfig";
import {ThorSoundConfig} from "../ThorSoundConfig";

/**
 * Created by Jerker Nord on 2019-04-02.
 */

export class ThorScatterNudgeController extends BeforeSpinStopPresentationController {

    private static readonly NUDGE_SPEED:number = 1;

    private _collectedScattersAfter:number;
    private _collectedScatterBefore:number;
    private _reels:string[][];
    private _scatterNudge:boolean = false;
    private _topSyms:string[];
    private _scatterPositions:number[];
    private _reelsToNudge:boolean[];
    private _scattersToCollect:boolean[];
    private _previousReelsToNudge:boolean[];
    private _reelsNudging:boolean[];
    private _scatterRespinTriggeredThisSpin:boolean;
    private _isRestore:boolean;

    constructor(index:number) {
        super(index, "ScatterNudge");
        this._reelsToNudge = [false, false, false, false, false];
        this._scattersToCollect = [false, false, false, false, false];
        this._previousReelsToNudge = [false, false, false, false, false];
        this._reelsNudging = [false, false, false, false, false];
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_RESTORE, (event:GameEvent) => this.onRestore());
    }

    private onInitDataParsed(data:ThorParsedInitData):void {
        this._scatterRespinTriggeredThisSpin = data.scatterRespinTriggeredThisSpin;
        this._isRestore = data.isRestoreState;
        for(let i:number = 0; i < data.reels.length; i++) {
            this._previousReelsToNudge[i] = this._reelsToNudge[i];
            for(let j:number = 3; j < 6; j++) {
                if(data.reels[i][j] == "S" && j < 5) {
                    this._reelsToNudge[i] = true;
                    if(j == 5 && data.mode == ThorGameMode.SCATTER_RESPIN) {
                        this._scattersToCollect[i] = true;
                    }
                    break;
                } else {
                    this._reelsToNudge[i] = false;
                    this._scattersToCollect[i] = false;
                }
            }
        }
    }

    private onRestore():void {

    }

    protected parseFeatureTriggered(data:ThorParsedGameData):boolean {
        this._collectedScatterBefore = data.collectedScattersBefore;
        this._collectedScattersAfter = data.collectedScattersAfter;

        //Set latest reel data
        this._reels = data.reels;

        if((data.mode == ThorGameMode.SCATTER_RESPIN && data.nextMode == ThorGameMode.SCATTER_RESPIN) ||
            (data.mode == ThorGameMode.SCATTER_RESPIN && data.nextMode == ThorGameMode.NORMAL) ||
            (data.mode == ThorGameMode.SCATTER_RESPIN && data.nextMode == ThorGameMode.FREESPIN)
        ) {
            this._scatterNudge = true;
        }

        if(data.mode == ThorGameMode.SCATTER_RESPIN || data.nextMode == ThorGameMode.SCATTER_RESPIN) {
            this._topSyms = [];
            this._scatterPositions = <number[]>(data.scatterPositions);
            for(let i:number = 0; i < data.reels.length; i++) {
                if(data.reels[i][3] == "S") {
                    this._topSyms.push(data.reels[i][2]);
                } else {
                    this._topSyms.push(data.reels[i][3]);
                }
                this._previousReelsToNudge[i] = this._reelsToNudge[i];
                for(let j:number = 3; j < 6; j++) {
                    if(data.reels[i][j] == "S" && j < 5) {
                        this._reelsToNudge[i] = true;
                        if(j == 5 && data.mode == ThorGameMode.SCATTER_RESPIN) {
                            this._scattersToCollect[i] = true;
                        }
                        break;
                    } else {
                        this._reelsToNudge[i] = false;
                        this._scattersToCollect[i] = false;
                    }
                }
            }
        }
        return this._scatterNudge;
    }

    protected getSpinStopDelay(data:ThorParsedGameData):number {
        return GameSetting.isFastSpin ? 1 : 1.5;
    }

    protected startPresentation(timeline:TimelineLite):void {
        this._scatterNudge = false;
        let scatterNudgeSoundPlaying:boolean = false;
        let reelsToNudge:boolean[];

        reelsToNudge = this._previousReelsToNudge;

        for(let i:number = 0; i < reelsToNudge.length; i++) {
            if(reelsToNudge[i] == true) {
                for(let j:number = 0; j < 3; j++) {
                    if(Reels.getSymbol(i, j)!.symName !== "S") {
                        timeline.add(() => Reels.getSymbol(i, j)!.changeState({
                            state : ThorGameConfig.instance.SYMBOL_STATES.normal,
                            fadeInDuration : 0.3
                        }));
                    }
                }
                timeline.add(() => this.replaceSymbol(i));
                // Don't nudge if Scatter has reached bottom of reel
                if(Reels.getSymbol(i, 2)!.symName !== "S") {
                    this._reelsNudging[i] = true;
                    timeline.add(() => (<ThorRespinNudgeReelController>Reels.getReel(i)).nudge(1, ThorScatterNudgeController.NUDGE_SPEED, Elastic.easeIn.config(1, 1), 0));
                    if(scatterNudgeSoundPlaying == false) {
                        scatterNudgeSoundPlaying = true;
                        timeline.add(() => SlotGame.sound.playEffect(ThorSoundConfig.instance.SCATTER_NUDGE));
                    }
                } else {
                    this._reelsNudging[i] = false;
                }
            }
        }
        timeline.add(() => this.doNothing(), "+=1.5");
    }

    private doNothing():void {

    }

    private replaceSymbol(reelId:number):void {
        Reels.getSymbol(reelId, -1)!.replaceWith(this._topSyms[reelId], reelId);
    }

    private getCollectedScatters(reelId:number):boolean {
        if(this._collectedScattersAfter > 0) {
            return true;
        }
        return false;
    }

    private getScatterCounterDelay(reelId:number):number {
        let delay:number = 0;
        if(this._collectedScattersAfter > 0) {
            delay = 1.5;
        }
        return delay;
    }

    protected stopPresentation(isAborted:boolean):void {
        if(isAborted == true) {
            for(let i:number = 0; i < this._reelsNudging.length; i++) {
                if(this._reelsNudging[i] == true) {
                    (<ThorRespinNudgeReelController>Reels.getReel(i)).abortNudge();
                }
            }
        }
    }

    protected resetFeature() {
        //TODO: Do reset?
    }
}